module.exports = __webpack_public_path__ + "static/media/felipe-omae.b1177d36.jpg";